export const initialState = {
  values: {
    activity: "",
    myToDoActivitiesId: "",
    notifyByEmail: '',
    notifyBySMS: '',
    reminderDate: '',
  },
  errors: {
    activity: "",
    myToDoActivitiesId: "",
    notifyByEmail: '',
    notifyBySMS: '',
    reminderDate: '',
  },
}
